/* Copyright (c) 2022, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

export interface LogEvent {
    logModule?: string; // Name of the nv-internal library which is sending logs
    timeStamp: string; // Timestamp at which log is added
    logLevel: string; // Should match LogLevel enum below
    logTag: string; // Name of the internal component inside the library which is printing the log
    logStr: string; // Actual log string
}

export enum LogLevel {
    INFO = 'INFO',
    WARN = 'WARN',
    DEBUG = 'DEBUG',
    ERROR = 'ERROR'
}
